var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgCircleProgress75 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 8,
    stroke: "#38DA8B",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 9C3 10.1867 3.35189 11.3467 4.01118 12.3334C4.67047 13.3201 5.60754 14.0892 6.7039 14.5433C7.80026 14.9974 9.00666 15.1162 10.1705 14.8847C11.3344 14.6532 12.4035 14.0818 13.2426 13.2426C14.0818 12.4035 14.6532 11.3344 14.8847 10.1705C15.1162 9.00666 14.9974 7.80026 14.5433 6.7039C14.0892 5.60754 13.3201 4.67047 12.3334 4.01118C11.3467 3.35189 10.1867 3 9 3L9 9L3 9Z",
    fill: "#38DA8B"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCircleProgress75);
const Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;